import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import classNames from 'classnames';
import ReactSelect from 'react-select';
import { components } from '../../Utils/ReactSelectComponents';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import green from '@material-ui/core/colors/green';
import NegotiationCQlotsAPI from '../../../API/NegotiationCQlotsAPI';
import SnackbarAlert from '../../Utils/SnackbarAlert';
import { handleServerError } from '../../../Utils/Helper';


const modalStyles = theme => ({
  paper: {
    position: 'absolute',
    width: '50%',
    minWidth: 240,
    backgroundColor: theme.palette.background.paper
  },
  toolbarRoot: {
    padding: 0,
    backgroundColor: theme.palette.primary[500]
  },
  titleHead: {
    margin: '4px 12px',
    color: '#ffffff'
  },
  iconRight: {
    position: 'absolute',
    right: '12px',
    marginTop: '40px'
  },
  formRoot: {
    flexGrow: 1,
    margin: '12px'
  },
  width100: {
    width: '100%'
  },
  footer: {
    display: 'flex',
    position: 'relative'
  },
  buttonSuccess: {
    backgroundColor: green[400],
    '&:hover': {
      backgroundColor: green[600],
    },
  },
  fabProgress: {
    position: 'absolute',
    right: 2,
    bottom: 2,
    zIndex: 1
  },
  button: {
    margin: theme.spacing.unit,
  },
  buttonSize: {
    width: '36px',
    height: '36px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblAdd: {
    color: '#ffffff',
    borderRadius: '50%',
    border: '1px solid #ffffff'
  },
  paddingAlign: {
    paddingTop: '6px'
  },
  //DON'T REMOVE (Used in ReactSelectComponents)
  noOptionsMessage: {
    padding: `${theme.spacing.unit / 2}px`
  },
  input: {
    display: 'flex',
    padding: 0
  }
});

function getModalPosition() {
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  };
}

function InputNumber(props) {
  const { inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({ target: { value: values.value } });
      }}
      allowNegative={false}
      maxLength={4}
      decimalScale={0}
    />
  );
}
InputNumber.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};


class NegotiationCQModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openModal: false,
      loading: false,
      success: false,
      color: '',
      qtty: '',
      openError: false,
      alertMessage: ''
    };
  }

  handleChangeSelect = name => value => {
    this.setState({ [name]: value });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };

  handleOpen = (cqLotId) => {
    let colorInfo = { value: cqLotId.ColorId, label: cqLotId.Color };
    this.setState({
      openModal: true,
      color: colorInfo,
      qtty: cqLotId.Quantity
    });
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      color: '',
      qtty: ''
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleCreate = () => {
    const NegotiationCQ_API = new NegotiationCQlotsAPI();
    this.setState({ loading: true })
    let negotiationNewL3DTO = this.parseStateForSubmit(this.state);
    NegotiationCQ_API.saveNewNegotiationCQ(negotiationNewL3DTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  handleEdit = () => {
    const NegotiationCQ_API = new NegotiationCQlotsAPI();
    this.setState({ loading: true })
    let negotiationEditL3DTO = this.parseStateForSubmit(this.state);
    NegotiationCQ_API.saveEditNegotiationCQ(negotiationEditL3DTO).then(() => {
      this.setState({
        loading: false,
        success: true,
      });
      setTimeout(() => {
        this.setState({
          success: false,
        });
        this.handleClose();
        this.props.reloadTable();
      }, 500)
    }).catch((error) => {
      this.setState({
        loading: false,
        success: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
      this.handleClose();
    });
  };

  parseStateForSubmit(estado) {
    return {
      L3ID: this.props.L3data ? this.props.L3data.L3Id : null,
      L1ID: this.props.L1ID,
      L2ID: this.props.L2ID,
      ColorId: estado.color.value,
      Quantity: estado.qtty
    };
  }


  render() {
    const { classes } = this.props;
    const { loading, success } = this.state;
    const buttonClassname = classNames({ [classes.buttonSuccess]: success });
    const shouldDisableActions = (this.props.estadoId !== 1 || !this.props.L2ID);
    return (
      <div>

        {this.props.newEditButton ?
          <Tooltip title='Novo L3' placement='left-end' >
            <IconButton variant='fab' aria-label='New' disabled={shouldDisableActions} onClick={this.handleOpen} className={classes.buttonSizeTbl}>
              <AddIcon className={classes.tblAdd} />
            </IconButton>
          </Tooltip>
          :
          <Tooltip title='Editar' placement='bottom' >
            <IconButton aria-label='Edit' disabled={this.props.estadoId !== 1} onClick={() => { this.handleOpen(this.props.L3data) }} className={classes.buttonSizeTbl} >
              <EditIcon />
            </IconButton>
          </Tooltip>
        }

        <Modal open={this.state.openModal} onClose={this.handleClose} disableAutoFocus={true}>
          <div style={getModalPosition()} className={classes.paper}>

            <Paper>
              <Toolbar className={classes.toolbarRoot}>
                {this.props.newEditButton ?
                  <Typography variant='title' id='newL3' className={classes.titleHead}>NOVO L3</Typography>
                  :
                  <Typography variant='title' id='editL3' className={classes.titleHead}>EDITAR L3</Typography>
                }
              </Toolbar>
            </Paper>

            <form className={classes.formRoot}>
              <Grid container spacing={8}>

                <Grid item xs={12} sm={6}>
                  {this.props.newEditButton ?
                    <Grid container justify='center'>
                      <div className={classes.width100}>
                        <InputLabel htmlFor='color'>
                          COR
                      </InputLabel>
                        <ReactSelect
                          classes={classes}
                          options={this.props.colorData}
                          components={components}
                          value={this.state.color}
                          onChange={this.handleChangeSelect('color')}
                          placeholder=''
                        />
                      </div>
                    </Grid>
                    :
                    <TextField
                      id='color'
                      label='COR'
                      fullWidth
                      value={this.state.color.label}
                      className={classes.paddingAlign}
                      InputProps={{ readOnly: true }}
                    />}
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    id='qtty'
                    label='QUANTIDADE'
                    fullWidth
                    className={classes.paddingAlign}
                    value={this.state.qtty}
                    onChange={this.handleChange('qtty')}
                    InputProps={{ inputComponent: InputNumber }}
                  />
                </Grid>

              </Grid>

              <Toolbar className={classes.footer}>
                <div className={classes.iconRight}>
                  <Tooltip title='Cancelar' placement='bottom' >
                    <Button variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize)} onClick={this.handleClose}>
                      <CloseIcon />
                    </Button>
                  </Tooltip>

                  {this.props.newEditButton ?
                    <span>
                      <Tooltip title='Guardar' placement='bottom' >
                        <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleCreate}>
                          {success ? <CheckIcon /> : <SaveIcon />}
                        </Button>
                      </Tooltip>
                      {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                    </span>
                    :
                    <span>
                      <Tooltip title='Guardar' placement='bottom' >
                        <Button disabled={loading} variant='fab' color='primary' className={classNames(classes.button, classes.buttonSize, buttonClassname)} onClick={this.handleEdit}>
                          {success ? <CheckIcon /> : <SaveIcon />}
                        </Button>
                      </Tooltip>
                      {loading && <CircularProgress size={48} color='primary' className={classes.fabProgress} />}
                    </span>}

                </div>
              </Toolbar>

            </form>
          </div>
        </Modal>

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </div>
    );
  }
}

NegotiationCQModal.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(modalStyles)(NegotiationCQModal);


// WEBPACK FOOTER //
// ./src/components/Negotiation/ColorQuantityLot/NegotiationCQModal.js